import Axios from 'axios'
import { createContext, useContext, useState, useEffect } from 'react'
import axios from 'axios'
import { baseURL } from '../services/api'

export const EditConfirmacaoCompraContext = createContext()

export function EditConfirmacaoCompraProvider({ children }) {
  const [dataPayment, setDataPayment] = useState([])
  const [dataPartner, setDataPartner] = useState([])
  const [vendedores, setVendedores] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  async function getInfoPayment(data) {
    try {
      const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/site/v2/pedido/busca-info-itens-pagamento/${data}`)

      setDataPayment(response.data)
    } catch (error) {
      console.log(error)
      setError(true)
    }
  }

  async function getInfoPartner(data) {
    try {
      const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/site/v2/pedido/busca-info-clientes-pagamento/${data}`)

      setDataPartner(response.data)

      return response.data
    } catch (error) {
      console.log(error)
      setError(true)
    }
  }

  async function updateEnterprises(codEmp, nunota) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-empresas', {
        codigo_empresa: codEmp,
        numero_nota: nunota,
      })
    } catch (error) {
      console.log(error)
    }
  }

  async function updateConsultor(codVend, nunota) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-consultor', {
        codigo_vendedor: codVend,
        numero_nota: nunota,
      })
    } catch (error) {
      console.log(error)
    }
  }

  async function editInfoFaturamento(codparc, nunota) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-faturamento', {
        codigo_parceiro: codparc,
        numero_nota: nunota,
      })
    } catch (error) {
      console.log(error)
    }
  }

  async function editInfoEntrega(codparc_dest, nunota) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-entrega', {
        codparc_dest: codparc_dest,
        numero_nota: nunota,
      })
    } catch (error) {
      console.log(error)
    }
  }

  async function editInfoDtSaida(dt_saida, nunota) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-dtsaida', {
        dt_saida: dt_saida,
        numero_nota: nunota,
      })
    } catch (error) {
      console.log(error)
    }
  }

  async function editInfoTransportadora(codigo_transportadora, nunota) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-transportadora', {
        codigo_transportadora: codigo_transportadora,
        numero_nota: nunota,
      })

      console.log('Transportadora: ', response)
    } catch (error) {
      console.log(error)
    }
  }

  async function editInfoDataSaida(data, nunota) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-data-saida', {
        data: data,
        numero_nota: nunota,
      })

      console.log('Transportadora: ', response)
    } catch (error) {
      console.log(error)
    }
  }

  async function editInfoProduct(codigo_produto, nunota, sequencia, cor) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-produto', {
        codigo_produto: codigo_produto,
        numero_nota: nunota,
        sequencia: sequencia,
        cor: cor,
      })
    } catch (error) {
      console.log(error)
    }
  }
  async function editInfoProductColor(cor, item) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-produto-cor', {
        numero_nota: item.NUNOTA,
        sequencia: item.SEQUENCIA,
        codigo_produto: item.CODPROD,
        cor: cor,
      })
    } catch (error) {
      console.log(error)
    }
  }
  async function editInfoGravacao(gravacao, item) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-gravacao', {
        gravacao: gravacao,
        numero_nota: item.NUNOTA,
        sequencia: item.SEQUENCIA,
        codigo_produto: item.CODPROD,
      })
    } catch (error) {
      console.log(error)
    }
  }
  async function editInfoBatidas(qtdbatida, item) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-quantidade-batidas', {
        qtdbatida: qtdbatida,
        numero_nota: item.NUNOTA,
        sequencia: item.SEQUENCIA,
        codigo_produto: item.CODPROD,
      })
    } catch (error) {
      console.log(error)
    }
  }
  async function editInfoPrazoEntrega(prazo, item) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-prazo-entrega', {
        prazo: prazo,
        numero_nota: item.NUNOTA,
        sequencia: item.SEQUENCIA,
        codigo_produto: item.CODPROD,
      })
    } catch (error) {
      console.log(error)
    }
  }

  async function editInfoQuantidadeProduct(valorUnitario, quantidade, valorTotal, item, codusu) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-quantidade-produto', {
        valor: valorUnitario,
        valor_total: valorTotal,
        numero_nota: item.NUNOTA,
        sequencia: item.SEQUENCIA,
        codigo_produto: item.CODPROD,
        quantidade: quantidade,
        usuario: codusu,
      })

      console.log('Quantidade: ', response)
    } catch (error) {
      console.log(error)
    }
  }

  async function editInfoValorUnitario(valorUnitario, valorTotal, item) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-valor-unitario', {
        valor: valorUnitario,
        valor_total: valorTotal,
        numero_nota: item.NUNOTA,
        sequencia: item.SEQUENCIA,
        codigo_produto: item.CODPROD,
      })
    } catch (error) {
      console.log(error)
    }
  }
  async function editInfoValorFrete(valor, nunota) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-valor-frete', {
        valor: valor,
        numero_nota: nunota,
      })
    } catch (error) {
      console.log(error)
    }
  }
  async function editInfoTipoFrete(tipo_frete, nunota) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-tipo-frete', {
        tipo_frete: tipo_frete,
        numero_nota: nunota,
      })
    } catch (error) {
      console.log(error)
    }
  }
  async function editInfoLinkLayout(link, nunota, sequencia) {
    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/editar-info-link-layout', {
        link: link,
        numero_nota: nunota,
        sequencia: sequencia,
      })
    } catch (error) {
      console.log(error)
    }
  }

  async function listarVendedores() {
    try {
      const response = await Axios.get('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/listar-vendedores')

      console.log(response)
      setVendedores(response.data)
    } catch (error) {
      console.log(error)
    }
  }
  async function listarEmpresas() {
    try {
      const response = await Axios.get('https://api.innovationbrindes.com.br/api/site/v2/pedido/lista-empresas')

      return response.data
    } catch (error) {
      console.log(error)
    }
  }
  async function listarCoresDisponiveis(codprod) {
    try {
      const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/site/v2/produto/${codprod}/cores-disponiveis`)

      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async function excludeItem(item, codusu) {
    const params = {
      numero_nota: item.NUNOTA,
      sequencia: item.SEQUENCIA,
      codigo_produto: item.CODPROD,
      usuario: codusu,
    }

    const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/editar-pedido/excluir-info-produto', params)

    console.log(response)
  }

  return (
    <EditConfirmacaoCompraContext.Provider
      value={{
        dataPayment,
        dataPartner,
        getInfoPayment,
        getInfoPartner,
        loading,
        error,
        updateEnterprises,
        updateConsultor,
        editInfoFaturamento,
        editInfoEntrega,
        editInfoDtSaida,
        editInfoTransportadora,
        editInfoProduct,
        editInfoProductColor,
        editInfoGravacao,
        editInfoBatidas,
        editInfoPrazoEntrega,
        editInfoQuantidadeProduct,
        editInfoValorUnitario,
        editInfoValorFrete,
        editInfoTipoFrete,
        editInfoLinkLayout,
        listarVendedores,
        listarEmpresas,
        listarCoresDisponiveis,
        vendedores,
        editInfoDataSaida,
        excludeItem,
      }}
    >
      {children}
    </EditConfirmacaoCompraContext.Provider>
  )
}

export function useEditConfirmacaoCompra() {
  return useContext(EditConfirmacaoCompraContext)
}
